module.exports = __webpack_public_path__ + "static/img/Samsung@2x.6175eca3.png";